import React from 'react';

import useCurrentLang from '@/hooks/apps/useCurrentLang';

import SubtopSolution from '@/components/apps/ui/subtop/SubtopSolution';
import TransCustom from '@/components/apps/ui/transCustom/TransCustom';

import CustomFeaturesSection from './CustomFeaturesSection';
// import CustomProSection from './CustomProSection';
import CustomProcessSection from './CustomProcessSection';

export default function SolutionCustom() {
  const lang = useCurrentLang();

  const desktopImage =
    lang === 'en'
      ? {
          src: '/images/apps/solution/custom/SubtopSolution_img_01_en.webp',
          width: 1480,
          height: 786,
        }
      : {
          src: '/images/apps/solution/custom/SubtopSolution_img_01.webp',
          width: 1480,
          height: 806,
        };
  const mobileImage =
    lang === 'en'
      ? {
          src: '/images/apps/solution/custom/SubtopSolution_img_01_en_m.webp',
          width: 1006,
          height: 534,
        }
      : {
          src: '/images/apps/solution/custom/SubtopSolution_img_01_m.webp',
          width: 1005,
          height: 552,
        };

  return (
    <div className="flex flex-col gap-[100px] bg-apps-brandGrayBlack pb-[100px] text-apps-coreGrayWhite lg:gap-[clamp(100px,16.667vw,200px)] lg:pb-[clamp(100px,16.667vw,200px)]">
      <SubtopSolution
        subtitle="Custom Solution"
        title={<TransCustom i18nKey="내게 꼭 맞춘 Listen AI 커스텀 솔루션" />}
        desktopImage={desktopImage}
        mobileImage={mobileImage}
        imageAlt="Listen AI 커스텀 솔루션"
      />

      {/* 깔끔하게 원하는 소리만 감지 */}
      <CustomFeaturesSection />

      {/* 사운드 센스 프로 */}
      {/* FIXME: 섹션 컨텐츠 변경 시 주석 해제 */}
      {/* <CustomProSection /> */}

      {/* 솔루션 도입 프로세스 */}
      <CustomProcessSection />
    </div>
  );
}
